module.exports = __webpack_public_path__ + "static/finance-8370a4cf18f082a1ca1c248aa571deff.png";